angular.module('TetherApp').controller('BroadcastEditController', [
    '$scope',
    '$window',
    '$log',
    '$mdDialog',
    'broadcastService',
    function (
        $scope,
        $window,
        $log,
        $mdDialog,
        broadcastService
    ) {
        let self = this;

        self.isSendNow = false;
        self.simulateQuery = false;
        self.isDisabled = false;
        self.allLists = undefined;
        self.allExperiences = undefined;
        self.ctrl = undefined;
        self.experience_id = undefined;
        self.querySearch   = querySearch;
        self.selectedItemChange = selectedItemChange;
        self.searchTextChange   = searchTextChange;
        self.allLists = undefined;
        self.broadcast = undefined;
        self.sendAfter = undefined;
        self.hourAt = undefined;
        self.minuteAt = undefined;
        self.timeOfDay = undefined;
        self.hours = [
            {
                value: 0,
                text: '0'
            },
            {
                value: 1,
                text: '1'
            },
            {
                value: 2,
                text: '2'
            },
            {
                value: 3,
                text: '3'
            },
            {
                value: 4,
                text: '4'
            },
            {
                value: 5,
                text: '5'
            },
            {
                value: 6,
                text: '6'
            },
            {
                value: 7,
                text: '7'
            },
            {
                value: 8,
                text: '8'
            },
            {
                value: 9,
                text: '9'
            },
            {
                value: 10,
                text: '10'
            },
            {
                value: 11,
                text: '11'
            },
            {
                value: 12,
                text: '12'
            },
            {
                value: 13,
                text: '13'
            },
            {
                value: 14,
                text: '14'
            },
            {
                value: 15,
                text: '15'
            },
            {
                value: 16,
                text: '16'
            },
            {
                value: 17,
                text: '17'
            },
            {
                value: 18,
                text: '18'
            },
            {
                value: 19,
                text: '19'
            },
            {
                value: 20,
                text: '20'
            },
            {
                value: 21,
                text: '21'
            },
            {
                value: 22,
                text: '22'
            },
            {
                value: 23,
                text: '23'
            }
        ];
        self.minutes = [
            {
                value: 0,
                text: '00'
            },
            {
                value: 15,
                text: '15'
            },
            {
                value: 30,
                text: '30'
            },
            {
                value: 45,
                text: '45'
            }
        ];

        self.experiences = [];
        self.lists = [];
        self.displayedExperiences = [];
        self.displayedLists = [];

        self.timezones = [];

        self.myDate = new Date();
        self.minDate = new Date(
            self.myDate.getFullYear(),
            self.myDate.getMonth(),
            self.myDate.getDate()
        );
        self.maxDate = new Date(
            self.myDate.getFullYear(),
            self.myDate.getMonth() + 2,
            self.myDate.getDate());

        self.init = function () {
            angular.forEach(window.timezones, function( arrayValue, key ) {
                self.timezones.push({
                    value: key,
                    text: arrayValue.replace("&amp;", "&")
                });
            }, self);
        };

        function querySearch (query) {
            let results = query ? self.allLists.filter( createFilterFor(query) ) : self.allLists,
                deferred;
            if (self.simulateQuery) {
                deferred = $q.defer();
                $timeout(function () { deferred.resolve( results ); }, Math.random() * 1000, false);
                return deferred.promise;
            } else {
                return results;
            }
        }

        function searchTextChange(text) {
            //$log.info('Text changed to ' + text);
        }

        function selectedItemChange(item) {
            //$log.info('Item changed to ' + JSON.stringify(item));
        }

        function createFilterFor(query) {
            let lowercaseQuery = angular.$$lowercase(query);
            return function filterFn(list) {
                return (list.name.toLowerCase().indexOf(lowercaseQuery) === 0);
            };
        }

        let onUsersLists = function (data) {
            self.allLists = data;
            self.allLists.forEach(function (list) {
                if (list.name == self.broadcast.name) {
                    self.selectedItem = list;
                }
            });
        };

        self.loadLists = function () {
            broadcastService.getUsersLists().then(onUsersLists, onError);
        };

        let onError = function(reason) {};

        let onEdit = function (data) {
            self.sendBroadcastCallBack1();
            self.sendBroadcastCallBack2();
        };

        self.loadBroadcast = function(broadcast) {
            self.broadcast = broadcast;
            if (self.broadcast.send_after != null && self.broadcast.send_after != '') {
                let broadcastSendAfter = self.broadcast.send_after.split(/[- :]/);
                let sendAfter = new Date(
                    broadcastSendAfter[0],
                    broadcastSendAfter[1] - 1,
                    broadcastSendAfter[2],
                    broadcastSendAfter[3],
                    broadcastSendAfter[4],
                    broadcastSendAfter[5]
                );
                self.broadcast.send_after = sendAfter.getFullYear()
                    + "-" + ((sendAfter.getMonth()+1) < 10 ? '0' : '') + (sendAfter.getMonth()+1)
                    + "-" + (sendAfter.getDate() < 10 ? '0' : '') + sendAfter.getDate()
                    + " " + ((sendAfter.getHours() < 10 ? '0' : '') + sendAfter.getHours())
                    + ":" + ((sendAfter.getMinutes() < 10 ? '0' : '') + sendAfter.getMinutes())
                    + ":" + ((sendAfter.getSeconds() < 10 ? '0' : '') + sendAfter.getSeconds());

                self.myDate = sendAfter;
                self.hourAt = sendAfter.getHours();
                self.minuteAt = sendAfter.getMinutes();
            }
            self.loadLists();

            if (!self.broadcast.campaign_id) {
                self.displayedExperiences = JSON.parse(JSON.stringify(self.experiences));
                self.displayedLists = JSON.parse(JSON.stringify(self.lists));
            } else {
                self.campaignUpdated();
            }
        };

        self.campaignUpdated = function() {
            self.displayedLists = [];
            self.displayedExperiences = [];
            self.lists.forEach(function(list) {
                list.campaigns.forEach(function (campaign) {
                    if (self.broadcast.campaign_id === campaign.id) {
                        self.displayedLists.push(list);
                    }
                });
            });

            self.experiences.forEach(function (experience) {
                if (self.broadcast.campaign_id === experience.campaign_id) {
                    self.displayedExperiences.push(experience);
                }
            });
        };

        self.showAllLists = function () {
            self.displayedLists = JSON.parse(JSON.stringify(self.lists));
        };

        self.showAllExperiences = function () {
            self.displayedExperiences = JSON.parse(JSON.stringify(self.experiences));
        };

        let ConfirmDetailsModalController = function ($mdDialog) {
            let dCtrl = this;
            dCtrl.broadcast = self.confirmDetailsModalBroadcast;
            dCtrl.campaigns = self.confirmDetailsModalCampaigns;
            dCtrl.lists = self.confirmDetailsModalLists;
            dCtrl.experiences = self.confirmDetailsModalExperiences;

            dCtrl.showObjectName = function (type, objectId) {
                if (!type) {
                    return '';
                }

                let objectName = '';
                if (dCtrl[type] && dCtrl[type].constructor === Array) {
                    dCtrl[type].forEach(function (item) {
                        if (item.id == objectId) {
                            objectName = item.name;
                        }
                    });
                }

                return objectName;
            };

            dCtrl.confirm = function () {
                $mdDialog.hide();
                document.querySelector('#broadcastForm').submit();
            };

            dCtrl.hide = function () { $mdDialog.hide(); };
            dCtrl.cancel = function () { $mdDialog.cancel(); };
        }

        self.confirmDetailsModal = function (ev) {
            self.confirmDetailsModalBroadcast = self.broadcast;
            self.confirmDetailsModalCampaigns = self.campaigns;
            self.confirmDetailsModalLists = self.displayedLists;
            self.confirmDetailsModalExperiences = self.displayedExperiences;
            ConfirmDetailsModalController.$inject = ['$mdDialog'];
            return $mdDialog.show({
                controller: ConfirmDetailsModalController,
                controllerAs: 'modalController',
                templateUrl: '/broadcast/partials/confirm-details',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                escapeToClose: true
            });
        };

        self.editBroadcast = function(callback1, callback2) {
            let isConfirmed = true;
            let isValid = true;
            if (self.broadcast != undefined && self.broadcast != '') {
                if (self.myDate != undefined && self.myDate != '') {
                    if (self.isSendNow) {
                        self.myDate = new Date();
                        if (!$window.confirm(self.sendNowConfirmationText)) {
                            isValid = false;
                        }
                    } else {
                        self.myDate.setHours(0);
                        self.myDate.setMinutes(0);
                        self.myDate.setSeconds(0);
                    }
                    if (!self.isSendNow) {
                        if (self.hourAt == undefined
                            && self.minuteAt == undefined) {
                            if (!$window.confirm(self.sendNowConfirmationText)) {
                                isConfirmed = false;
                            }
                        }
                        if (self.hourAt != undefined && self.hourAt != '' && self.hourAt != 0) {
                            self.hourAt = parseInt(self.hourAt);
                            self.myDate.setHours(self.hourAt);
                        }
                        if (self.minuteAt != undefined && self.minuteAt != '' && self.minuteAt != 0) {
                            self.minuteAt = parseInt(self.minuteAt);
                            self.myDate.setMinutes(self.minuteAt);
                        }

                        let currentDate = new Date();
                        if (self.myDate < currentDate) {
                            isValid = false;
                            self.errors = [];
                            self.errors.push(self.dateInPastErrorText);
                        }
                    }

                    self.broadcast.send_after = self.myDate.getFullYear()
                        + "-" + (self.myDate.getMonth()+1)
                        + "-" + self.myDate.getDate()
                        + " " + ((self.myDate.getHours() < 10 ? '0' : '') + self.myDate.getHours())
                        + ":" + ((self.myDate.getMinutes() < 10 ? '0' : '') + self.myDate.getMinutes())
                        + ":" + ((self.myDate.getSeconds() < 10 ? '0' : '') + self.myDate.getSeconds());
                } else {
                    self.broadcast.myDate = undefined;
                    self.broadcast.send_after = self.myDate.getFullYear()
                        + "-" + (self.myDate.getMonth()+1)
                        + "-" + self.myDate.getDate()
                        + " " + ((self.myDate.getHours() < 10 ? '0' : '') + self.myDate.getHours())
                        + ":" + ((self.myDate.getMinutes() < 10 ? '0' : '') + self.myDate.getMinutes())
                        + ":" + ((self.myDate.getSeconds() < 10 ? '0' : '') + self.myDate.getSeconds());
                }

                if (isConfirmed && isValid) {
                    broadcastService.editBroadcast(
                        self.broadcast.id,
                        self.selectedItem.id,
                        self.broadcast.campaign_id,
                        $window.shortcode_id,
                        self.broadcast.title,
                        self.broadcast.message,
                        self.broadcast.send_after,
                        self.experience_id,
                        self.broadcast.message_fr
                    ).then(onEdit, onError);
                    self.sendBroadcastCallBack1 = callback1;
                    self.sendBroadcastCallBack2 = callback2;
                } else {
                    //Set hours back to 12 hour clock
                    if (self.hourAt > 12) {
                        if (self.hourAt != 12) {
                            self.hourAt -= 12;
                        }
                    }
                }
            }
        };

        self.dateChange = function () {
            let tempHourAt = (self.hourAt != undefined && self.hourAt != '')
                ? parseInt(self.hourAt)
                : 0;
            let tempMinuteAt = (self.minuteAt != undefined && self.minuteAt != '')
                ? parseInt(self.minuteAt)
                : 0;

            self.myDate.setHours(tempHourAt);
            self.myDate.setMinutes(tempMinuteAt);
            self.myDate.setSeconds(0);
            self.broadcast.send_after = self.myDate.getFullYear()
                + "-" + (self.myDate.getMonth()+1)
                + "-" + self.myDate.getDate()
                + " " + ((self.myDate.getHours() < 10 ? '0' : '') + self.myDate.getHours())
                + ":" + ((self.myDate.getMinutes() < 10 ? '0' : '') + self.myDate.getMinutes())
                + ":" + ((self.myDate.getSeconds() < 10 ? '0' : '') + self.myDate.getSeconds());

            // console.log(self.broadcast.send_after);
        };

        /**
         * You first need to create a formatting function to pad numbers to two digits
         **/
        function twoDigits(d) {
            if(0 <= d && d < 10) return "0" + d.toString();
            if(-10 < d && d < 0) return "-0" + (-1*d).toString();
            return d.toString();
        }

        /**
         * and then create the method to output the date string as desired.
         * Some people hate using prototypes this way, but if you are going
         * to apply this to more than one Date object, having it as a prototype
         * makes sense.
         **/
        Date.prototype.toMysqlFormat = function() {
            return this.getUTCFullYear() + "-" + twoDigits(1 + this.getUTCMonth()) + "-" + twoDigits(this.getUTCDate()) + " " + twoDigits(this.getUTCHours()) + ":" + twoDigits(this.getUTCMinutes()) + ":" + twoDigits(this.getUTCSeconds());
        };

        let onExperiencesList = function (data) {
            self.allExperiences = data;
        };

        self.loadExperienceList = function () {
            broadcastService.getExperienceList()
                .then(onExperiencesList, onError);
        }();

        $scope.cancel = function() {
            $scope.$parent.cancel();
        };

        self.confirmSkipOptionCheckModal = function (ev) {
            if (self.broadcast.skip_optin_check) {
                let confirmation = $mdDialog.confirm()
                    .title('Confirm skip opt-in check')
                    .textContent('Are you sure you want to SKIP the opt-in check?')
                    .cancel('Cancel')
                    .ok('Confirm');
                $mdDialog.show(confirmation)
                    .then(
                        function () {},
                        function () {
                            self.broadcast.skip_optin_check = false;
                        }
                    )
                    .finally(function() {
                        confirmation = undefined;
                    });
            }
        };
    }
]);
